var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0792 4.41185C11.3573 4.5651 11.5899 4.79386 11.7521 5.07362C11.9143 5.35339 12 5.67362 12 6.00001C12 6.32639 11.9143 6.64662 11.7521 6.92639C11.5899 7.20615 11.3573 7.43492 11.0792 7.58816L3.66151 11.7682C2.4671 12.442 1 11.566 1 10.1807V1.81993C1 0.433972 2.4671 -0.441402 3.66151 0.231178L11.0792 4.41185Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.4f9fbe2924f6e063216e58f989e3af7d.svg";
export { ForwardRef as ReactComponent };